<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="text-center alert alert-info w-100 h4" >
                <template #default>ثبت با موفقیت انجام شد.   </template>
                </m-h1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
